import { render, staticRenderFns } from "./EmergencyDriver.vue?vue&type=template&id=1052fb26"
import script from "./EmergencyDriver.vue?vue&type=script&lang=js"
export * from "./EmergencyDriver.vue?vue&type=script&lang=js"
import style0 from "./EmergencyDriver.vue?vue&type=style&index=0&id=1052fb26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports